import { useReveal } from "@/hooks/useReveal";

const BADGES = ["USDA Organic", "EU Organic", "HACCP", "INVIMA"];

export default function Hero() {
  const ref = useReveal<HTMLDivElement>();

  return (
    <section id="top" className="relative w-full min-h-[88vh] flex items-center">
      {/* Background image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://storage.helloreaddy.io/project_files/1d5eebb5-cdd6-4798-a44f-e501204aaa58/2bdc2c03-bd7d-48a0-b99e-89b18ed364ee_compressed_hero-bg.webp"
          alt="Sugar cane field on the slopes of Colombia's coffee region at golden hour"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-ink/85 via-ink/60 to-ink/35"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/10 to-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-[1200px] mx-auto px-4 md:px-6 py-32 md:py-40">
        <div className="max-w-[60%] min-w-[320px]">
          <div ref={ref} className="reveal">
            <h1 className="text-white font-serif text-4xl md:text-5xl lg:text-[56px] leading-[1.08] font-semibold">
              Certified organic cane sugar and cocoa from Colombia — now opening
              South Africa
            </h1>

            <p className="mt-6 text-cream/95 text-base md:text-lg leading-relaxed max-w-xl">
              Mesa Baja is a family-run producer in Colombia&apos;s coffee
              region. Ecocert certified for USDA and EU Organic, HACCP, and
              shipping full-documentation containers to Germany, Australia,
              Chile and Romania. We are now selecting partners in South Africa.
            </p>

            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <a
                href="#quote"
                className="inline-flex items-center justify-center whitespace-nowrap px-6 py-3.5 rounded-md bg-brand text-white text-base font-semibold hover:bg-brand-dark transition-colors"
              >
                Request a wholesale quote
              </a>
              <a
                href="#certifications"
                className="inline-flex items-center justify-center whitespace-nowrap px-6 py-3.5 rounded-md border-2 border-white/80 text-white text-base font-semibold hover:bg-white/10 transition-colors"
              >
                Download technical data sheet
              </a>
            </div>
          </div>

          {/* Trust strip */}
          <div className="mt-10 inline-flex flex-wrap items-center gap-x-6 gap-y-3 px-5 py-3.5 rounded-md bg-white/10 backdrop-blur-sm border border-white/20">
            {BADGES.map((badge) => (
              <span
                key={badge}
                className="inline-flex items-center gap-2 text-white/90 text-sm font-medium"
              >
                <i className="ri-verified-badge-line text-base opacity-80"></i>
                {badge}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}